/**
 * The one gate of every Advanced (BI) search (CU-869fmk5ge D8 c, TL B2 c): Search, `run=1`, "Filter by specific office"
 * and Try again all go through `useSubmit`, which posts only when the form passes the schema and the question being
 * answered has nothing left to choose. The schema comes as a parameter (it reads signals behind aliases), so
 * `node --test` runs this.
 */
export function canSubmit(form, schema, goalMissing = []) {
	if (!form || typeof form !== 'object' || goalMissing?.length) return false
	try {
		return !!schema?.isValidSync?.(form)
	} catch {
		return false
	}
}

// The fields of the form as its labels say them (`Filters/index.jsx`), in the form's order
const FIELD_LABELS = [
	['reportType', 'How to group'],
	['officePickupID', 'Pick up Office'],
	['officeGroupID', 'Pickup office Group'],
	['siteID', 'Site'],
	['startBookingDate', 'Booking date range'],
	['endBookingDate', 'Booking date range'],
	['startPickupDate', 'Pickup date range'],
	['endPickupDate', 'Pickup date range'],
	['categoryID', 'Categories'],
	['lor', 'Length of Rental'],
	['currency', 'Currency'],
	['isPreviousComparison', 'Days/Years compare'],
]

/** "Missing: …" next to Search (UX Obs. 5): the schema's errors and what the question still asks to choose */
export function missingLabels(errors, goalMissing) {
	const keys = new Set([...Object.keys(errors || {}).filter(k => errors[k]), ...(goalMissing || [])])
	return [...new Set(FIELD_LABELS.filter(([k]) => keys.has(k)).map(([, label]) => label))]
}
